import React from 'react';

import { Attachment } from '../Attachment';
import { GateOverlay } from './GateOverlay';
import { RelatedPapers } from '../interstitials/RelatedPapers';
import { RelatedPaper } from '../interstitials/types';

type GatedAttachmentVariant = 'blur_page_2' | 'blur_33_percent';

export type GatedAttachmentProps = {
  attachmentId: string;
  firstPageUrl?: string;
  totalPages: number;
  universityCount: number;
  variant: GatedAttachmentVariant;
  className?: string;
  relatedPapers?: RelatedPaper[];
  userInChina: boolean;
};

const calculateVisiblePages = (
  variant: GatedAttachmentVariant,
  totalPages: number,
): number => {
  if (variant === 'blur_page_2') return 1;
  return Math.max(1, Math.floor(totalPages * 0.33));
};

export const GatedAttachment: React.FC<GatedAttachmentProps> = ({
  attachmentId,
  firstPageUrl,
  totalPages,
  universityCount,
  variant,
  className,
  relatedPapers = [],
  userInChina,
}) => {
  const visiblePages = calculateVisiblePages(variant, totalPages);

  return (
    <div className={className}>
      <div className="gated-attachment__pdf-area">
        <Attachment
          attachmentId={attachmentId}
          firstPageUrl={firstPageUrl}
          pages={visiblePages}
          shown={true}
          className="ungated-pdf-viewer-panel__attachment"
          trailingPageClassName="gated-attachment__blurred-page"
        />
        {firstPageUrl && (
          <div className="gated-attachment__overlay-positioner">
            <GateOverlay
              universityCount={universityCount}
              userInChina={userInChina}
            />
          </div>
        )}
      </div>
      <RelatedPapers papers={relatedPapers} marginBottom={false} />
    </div>
  );
};
